import React, { Suspense, lazy } from 'react';
import { HeroSection } from '../components/HeroSection';
import { StickyCTA } from '../components/StickyCTA';
import { LazyMount } from '../components/LazyMount';
const TrustBar = lazy(() => import('../components/TrustBar').then(m => ({
  default: m.TrustBar
})));
const ContrastSection = lazy(() => import('../components/ContrastSection').then(m => ({
  default: m.ContrastSection
})));
const ForWhomSection = lazy(() => import('../components/ForWhomSection').then(m => ({
  default: m.ForWhomSection
})));
const BenefitsSection = lazy(() => import('../components/BenefitsSection').then(m => ({
  default: m.BenefitsSection
})));
const ContentPreview = lazy(() => import('../components/ContentPreview').then(m => ({
  default: m.ContentPreview
})));
const BonusSection = lazy(() => import('../components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const PricingSection = lazy(() => import('../components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const GuaranteeSection = lazy(() => import('../components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const TestimonialsSection = lazy(() => import('../components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const ExpertSection = lazy(() => import('../components/ExpertSection').then(m => ({
  default: m.ExpertSection
})));
const FAQSection = lazy(() => import('../components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const Footer = lazy(() => import('../components/Footer').then(m => ({
  default: m.Footer
})));
const SocialProofPopup = lazy(() => import('../components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
/**
 * Each section gets a viewport-sized placeholder so the page has real scroll
 * height. Without this, all the empty placeholders stack near the top and
 * IntersectionObserver fires on every section at once → "loads everything at
 * once" behaviour. Using vh units (or generous px heights) ensures sections
 * are actually below the fold until the user scrolls.
 */
export function LandingPage() {
  return <main className="w-full min-h-screen bg-bg-main font-inter selection:bg-primary/30" data-id="element-296">
      <div data-id="element-297">
        {/* Hero loads eagerly (LCP) */}
        <HeroSection data-id="element-298" />

        <Suspense fallback={null} data-id="element-299">
          {/* TrustBar is just below the hero, give it a smaller rootMargin */}
          <LazyMount minHeight="40vh" rootMargin="200px" data-id="element-300">
            <TrustBar data-id="element-301" />
          </LazyMount>

          <LazyMount minHeight="100vh" rootMargin="150px" data-id="element-302">
            <ContrastSection data-id="element-303" />
          </LazyMount>

          <LazyMount minHeight="100vh" rootMargin="150px" data-id="element-304">
            <ForWhomSection data-id="element-305" />
          </LazyMount>

          <LazyMount minHeight="100vh" rootMargin="150px" data-id="element-306">
            <BenefitsSection data-id="element-307" />
          </LazyMount>

          <LazyMount minHeight="120vh" rootMargin="150px" data-id="element-308">
            <ContentPreview data-id="element-309" />
          </LazyMount>

          <LazyMount minHeight="100vh" rootMargin="150px" data-id="element-310">
            <BonusSection data-id="element-311" />
          </LazyMount>

          <LazyMount minHeight="120vh" rootMargin="150px" data-id="element-312">
            <PricingSection data-id="element-313" />
          </LazyMount>

          <LazyMount minHeight="60vh" rootMargin="150px" data-id="element-314">
            <GuaranteeSection data-id="element-315" />
          </LazyMount>

          <LazyMount minHeight="120vh" rootMargin="150px" data-id="element-316">
            <TestimonialsSection data-id="element-317" />
          </LazyMount>

          <LazyMount minHeight="60vh" rootMargin="150px" data-id="element-318">
            <ExpertSection data-id="element-319" />
          </LazyMount>

          <LazyMount minHeight="100vh" rootMargin="150px" data-id="element-320">
            <FAQSection data-id="element-321" />
          </LazyMount>

          <LazyMount minHeight="40vh" rootMargin="100px" data-id="element-322">
            <Footer data-id="element-323" />
          </LazyMount>

          {/* Popup is fixed-positioned, mount near end-of-page */}
          <LazyMount minHeight={0} rootMargin="0px" data-id="element-324">
            <SocialProofPopup data-id="element-325" />
          </LazyMount>
        </Suspense>

        {/* Sticky CTA stays eager to be available as the user scrolls */}
        <StickyCTA data-id="element-326" />
      </div>
    </main>;
}